module.exports = __webpack_public_path__ + "static/media/editDashboardBlue.a1440afb.svg";